import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import type { ViewerDocumentData } from "@/domains/documents/hooks/useDocumentViewer";
import { MessageBoard } from "./MessageBoard";
import { ChannelSwitcher } from "./ChannelSwitcher";
import type { Channel } from "./ChannelDropdown";

interface MessageBoardModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  channels: Channel[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  buildingId: number;
  openViewer: (doc: ViewerDocumentData) => Promise<void>;
}

/** Expanded full-screen board: channel column + chat feed + composer. */
export function MessageBoardModal({
  open,
  onOpenChange,
  channels,
  selectedId,
  onSelect,
  buildingId,
  openViewer,
}: MessageBoardModalProps) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[85vh] max-w-[90vw] gap-0 overflow-hidden p-0">
        <ChannelSwitcher channels={channels} selectedId={selectedId} onSelect={onSelect} />
        <div className="flex min-h-0 min-w-0 flex-1 flex-col p-4">
          <DialogTitle className="mb-3 text-base font-semibold">{t.messages.title}</DialogTitle>
          {selectedId != null && (
            <MessageBoard
              buildingId={buildingId}
              buildingProjectId={selectedId}
              openViewer={openViewer}
              className="flex-1"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
